<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">简介</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">质押机制</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">质押权重</a></p>
          <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">惩罚</a></p>
          <div class="subAnchor">
            <!-- <p @click="activeted(6)" class="s2"><a :class="{active:flag==6}" href="#box6">33333333</a></p> -->
    
          </div>
        </div>
      </div>
      <div class="p1">委托人概述</div>
      <div id="box1" class="p2">简介</div>
      <div class="p3">Fax 基于 Tendermint，依赖于一组负责提交区块的验证器。这些验证者通过广播投票参与共识协议，其中包含由每个验证者的私钥签名的加密签名。</div>
      <div class="p3">代币持有者可以通过“委托”命令委托质押权，并选择他们认为对生态系统有意义的验证者。这些代币持有者被称为委托人。</div>
      <div id="box2" class="p2">质押机制</div>
      <div class="p3">在 Fax 中，任何质押 Fax 代币的用户都可以向目标验证者添加质押权利。每个用户都可以使用其全部股份权重为最多 1 名验证候选人添加质押权。例如，如果用户质押了Fax，则他有权向多达 1 个验证者共享权益。前 23 名验证者由收集到的 Fax 质押权总数决定。额外的验证人，按他们质押的 Fax 总数排名，也由网络补偿，作为验证人候选人。</div>
      <div class="p3">Fax 正在实施委托治理。用户可以选择直接向验证者添加质押权，但他们也可以将质押权委托给其他账户，以允许其他人代表他们参与 POS 协议。被称为代理的委托账户无法控制原始用户的账户——用户可以在不交出任何密钥的情况下无需信任地代理他的抵押权。代理有权对某些验证者使用委托的质押权力，但用户可以在任何时间点从代理撤销这种质押权力。</div>
      <div class="p3">在代理质押机制中，有两个角色：</div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>委托人</li>
          <li>代理委托人</li>
        </ul>
      </div>
      <div class="p4">委托人</div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>您可以通过发送代理委托人注册交易来注册为代理委托人。</li>
          <li>只能选择一个代理作为代理委托人。</li>
          <li>通过执行代理绑定交易与代理委托人建立质押关系。</li>
          <li>选择代理后，用户帐户中的所有质押权限均由代理委托人管理。</li>
          <li>获得的代理质押权数量将实时更新。</li>
          <li>通过执行取消代理关系的事务来结束代理关系。</li>
        </ul>
      </div>
      <div class="p4">代理委托人</div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>通过启动特定的 tx 注销从代理委托人转移到委托人。</li>
          <li>您必须已存款才能注册为代理委托人。一旦代理委托人的存款完全解绑，代理委托人身份将被自动取消。</li>
          <li>代理委托人允许多个目标进行质押。</li>
          <li>每当代理委托人所代表的委托人更改存款金额时，代理委托人的所有质押权都会同时更新。</li>
          <li>代理委托人只记录将质押权利绑定到代理委托人的委托人。</li>
          <li>注册为代理委托人时，您不能再将您的权利委托给其他人（不是多个代理）。</li>
          <li>当代理委托人注销时，代理委托人所代表的质押权立即清零，质押节点的质押权重也实时降低。</li>
        </ul>
      </div>
      <div id="box3" class="p2">质押权重</div>
      <div class="p3">质押权的权重每周都会减少（UTC+8 时间每周一 07:05:02）。选票权重将使用以下公式计算：</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0">start_timestamp = 1625439902 (ie UTC+8 Time: 2021-07-05 07:05:02)</div>
          <div style="padding:5px 0">weeks_per_year = 52</div>
          <div style="padding:5px 0">weight = (now_timestamp - start_timestamp) / (seconds_per_day * 7) / weeks_per_year</div>
          <div style="padding:5px 0">shares = delegated_tokens * weight</div>
        </div>
      </div>
      <div class="p3">最好的质押管理策略是每周增加一次质押权的调整，以确保所持有的质押权始终是最新的。</div>
      <div id="box4" class="p2">惩罚</div>
      <div class="p3">Fax 具有链上自动惩罚机制，目前针对两种类型的行为实施：</div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>当区块节点被用作验证者时，区块没有被签名。</li>
        </ul>
      </div>
      <div class="p3">
        <ul style="padding-left:60px">
          <li>在当前的测试网中，当累计区块签名达到 9500 个区块，将执行自动惩罚。- 处罚：监狱验证器 600s。</li>
          <li>验证者在监狱期间不能参与区块轮换。</li>
        </ul>
      </div>
      <div class="p3">
        <ul style="padding-left:30px">
          <li>一旦在测试网络中发现双签名块，将立即执行自动惩罚。</li>
        </ul>
      </div>
      <div class="p3">
        <ul style="padding-left:60px">
          <li>处罚：永久监禁</li>
          <li>验证者在监狱期间不能参与区块轮换。</li>
        </ul>
      </div>
      
    </div>
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">简介</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">质押机制</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">质押权重</a></p>
      <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">惩罚</a></p>
      <div class="subAnchor">
        <!-- <p @click="activeted(6)" class="s2"><a :class="{active:flag==6}" href="#box6">33333333</a></p> -->

      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolsOverview',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>